'use strict';

import { values, observe } from "mobx";

import setupElm from './setup-elm';
import fixProductsAlignment from './fix-product-alignment';
import { setupClickDropdown } from '../lib/dropdown';
import { getModel, replaceState } from '../lib/history';
import setupSidebar from './sidebar';




function getUrl ( page = null, filters = {}, url = null ) {
    const baseUrl = new URL(url || window.location);
    const filterParams = new URLSearchParams();

    if ( page > 1) {
        filterParams.set('page', page);
    }

    for ( const filterName in filters ) {
        filterParams.set(filterName, filters[filterName]);
    }

    const filterParamsString = filterParams.toString();
    baseUrl.searchParams.set('filters', filterParamsString);

    if ( filterParamsString.length === 0 ) {
        baseUrl.searchParams.delete('filters');
    }

    return baseUrl.toString();
}

function getFiltersFromUrl () {
    let filters = [];
    const urlParams = new URLSearchParams(window.location.search);

    if ( urlParams.get('filters') ) {
        const filterParams = new URLSearchParams(urlParams.get('filters'));

        for ( const param of filterParams ) {
            param[1]
                .split(',')
                .forEach(p => {
                    filters.push({
                        label: '',
                        name: param[0],
                        value: p,
                    });
                });
        }
    }

    return filters;
}

function setupUrl (page = null, filters = {}) {
    const newUrl = getUrl(page, filters);

    if ( window.location.href !== newUrl ) {
        history.pushState(
            {page, filters},
            '',
            newUrl
        );
    }
}

function excludeUrlParam (filter) {
    if ( filter.name === 'offset' && filter.value === '18' ) {
        return false;
    }

    if ( filter.name === 'sort' && filter.value === 'sort-no' ) {
        return false;
    }

    return true;
}

function formatSelectedFilters ( selectedFilters ) {
    return selectedFilters
        .reduce( (result, filter) => {
            return {
                ...result,
                [filter.name]: [
                    ...result[filter.name] || [],
                    filter.value,
                ],
            };

        }, {});
}

function setupRelTag ( name, page = null, filters = {} ) {
    const current = document.querySelector(`link[rel="${name}"]`);

    if ( page ) {
        const currentHref = current ? current.href : null;
        const url = getUrl(page, filters, currentHref);

        if ( current ) {
            current.href = url;
        } else {
            const rel = document.createElement('link');
            rel.rel = name;
            rel.href = url;

            document.querySelector('head').append(rel);
        }
    } else {
        if ( current ) {
            current.remove();
        }
    }
}

function setupHeaderTags ( info, filters ) {
    setupRelTag('canonical', info.currentPage, filters);
    setupRelTag('prev', info.prevPage, filters);
    setupRelTag('next', info.nextPage, filters);
}



const ElmConfig = [
    {
        selector: 'section.product-overview',
        moduleName: 'ProductOverview',
        formatFlags: function (dataset, elem) {
            const selectedFilters = getFiltersFromUrl();
            const page = selectedFilters.find(filter => filter.name === 'page');

            const model = getModel(window.history.state);

            if ( !model ) {
                elem.dataset.loading = true;
            }

            return [{
                pageType: dataset.pagetype !== undefined ?
                                dataset.pagetype : "",
                id: dataset.id !== undefined ?
                                parseInt(dataset.id) : null,
                search: dataset.search !== undefined ?
                                dataset.search : null,
                page: page !== undefined ?
                                parseInt(page.value) : 1,
                translations: window.productTranslations !== undefined ?
                                window.productTranslations : null,
                selectedFilters: selectedFilters.filter(filter => filter.name !== 'page'),
                },
                model,
            ];
        },
        ports: {
            scrollToTop () {
                // Scroll to top
                document.body.scrollIntoView({
                    'block': 'start',
                    'inline': 'start'
                });
            },

            updateSidebar () {
                window.setTimeout(() => {

                    setupSidebar();

                }, 100);
            },

            productsLoaded ({ page, filters, products, loadedProductsCount }) {

                window.setTimeout(() => {
                    fixProductsAlignment();
                }, 100);

                const elem = document.querySelector('.product-overview');
                elem.dataset.page = page;
                elem.dataset.loading = false;
                elem.dataset.searchLoading = false;

                if ( loadedProductsCount > 0 ) {
                  elem.dataset.noResults = false;
                } else {
                  elem.dataset.noResults = true;
                }
            },
            pageInfoLoaded (pageInfo) {
                const {info, selectedFilters} = pageInfo;

                window.setTimeout(() => {
                    document.querySelectorAll('.product-overview .dropdown')
                        .forEach(setupClickDropdown);
                }, 100);

                if ( info && info.totalProducts === 0 ) {
                    const productOverview = document.querySelector('.product-list .product-overview')

                    if ( productOverview ) {
                        const parentElem = productOverview.parentElement;
                        if ( parentElem && parentElem.classList.contains('product-list') ) {
                            parentElem.remove();
                        }
                    }
                }
            },
            addToCart (id) {
                window.store.product.addToCart({id, cartQuantity: 1, type_: 'Products'});
            },
            compareProduct (id) {
                window.store.product.compare(id);
            },
            pageChanged (page) {
                const elem = document.querySelector('.product-overview');
                elem.dataset.loading = true;
                elem.dataset.page = page;

                // Scroll to top
                if ( !document.body.classList.contains('search') ) {
                    document.body.scrollIntoView({
                        'behavior': 'smooth',
                        'block': 'start',
                        'inline': 'start'
                    });
                }
            },
            toggledFilters (filtersVisible) {
                const body = document.querySelector('body');

                if ( filtersVisible ) {
                    body.style.overflow = 'hidden';
                } else {
                    body.style.overflow = 'initial';
                }
            },

            storeModel (model) {

                const filters = formatSelectedFilters(model.selectedFilters.filter(excludeUrlParam));

                if ( document.querySelector('body.search') || document.querySelector('body.userpanel') ) {
                    // Search page
                    setupUrl(1, filters);
                } else {
                    if ( model.info ) {
                        setupUrl(model.info.currentPage, filters);
                        setupHeaderTags(model.info, filters);
                    }
                }

                if (
                    model.options &&
                    model.options.pageType &&
                    (model.options.pageType === 'nieuw' ||
                    model.options.pageType === 'sales' ||
                    model.options.pageType === 'favorites' )
                ) {
                    return;
                }

                replaceState(model);
            },
        },
        construct (module) {
            setupSidebar();
            const elem = document.querySelector('.product-overview');

            window.setTimeout(() => {
                fixProductsAlignment();
                document.querySelectorAll('.product-overview .dropdown')
                    .forEach(setupClickDropdown);
            }, 100);

            observe(window.store.product, 'compareProducts', () => {
                // Compare products
                const compareIds = values(window.store.product.compareProducts)
                                    .map(product => parseInt(product.id));

                module
                    .ports
                    .receiveCompare
                    .send(compareIds);
            });


            // History
            addEventListener('popstate', (event) => {
                const model = getModel(event.state);

                module
                    .ports
                    .receivedModel
                    .send(model);
            });


            // Infinity scroll search
            const productsOverview = document.querySelector('body.search .product-overview');
            if ( productsOverview ) {
                const products = productsOverview.querySelector('.products');

                window.addEventListener('scroll', () => {
                    const windowHeight = window.innerHeight;
                    const elementBottom = products.getBoundingClientRect().bottom;

                    if (productsOverview.dataset.noResults === 'true') return;

                    if ( elementBottom - (windowHeight*2) < 0 && productsOverview.dataset.searchLoading !== 'true' ) {
                        productsOverview.dataset.searchLoading = true;
                        let currentPage = 1;
                        if ( productsOverview.dataset.page ) {
                            currentPage = parseInt(productsOverview.dataset.page);
                        } else {
                            const model = getModel(window.history.state);

                            if ( model && model.options && model.options.page ) {
                                currentPage = model.options.page;
                            }
                        }

                        let filters = [];
                        if ( window.history.state && window.history.state.filters !== null ) {
                            for ( const name in window.history.state.filters ) {
                                for ( const option of window.history.state.filters[name] ) {
                                    filters.push({
                                        label: '',
                                        name: name,
                                        value: option
                                    });
                                }
                            }
                        }

                        module
                            .ports
                            .changePage
                            .send([currentPage + 1, filters]);
                    }
                });
            }
        }
    },
];





export default function setupProductOverview () {

    // Fix replaceData for Google Translate compatibility with Elm
    HTMLFontElement.prototype.replaceData =
        function replaceData(_0, _1, string) {
            this.parentNode.replaceChild(
                document.createTextNode(string),
                this
            );
        };

    ElmConfig.forEach(setupElm);
}
